/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxTerminate } from "../../funcs/sandboxTerminate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.TerminateSessionRequest$inboundSchema,
};

export const tool$sandboxTerminate: ToolDefinition<typeof args> = {
  name: "sandbox-terminate",
  description: `Terminate Session

Stop a sandbox session and release the backing sandbox resources.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxTerminate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
